import { cached } from '@porotutu/react'
import { listQueryOf } from '@porotutu/react/paging'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { permittedRoute, signedInRoute } from '@/router/root'
import { CRM_CUSTOMER_SORTABLE } from '../vocabulary'
import { customerQuery, customersQuery } from './queries'

const customerSearch = (raw: Record<string, unknown>) => listQueryOf(raw, CRM_CUSTOMER_SORTABLE)

export const customersRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('customers'),
  path: '/customers',
  validateSearch: customerSearch,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => context.queryClient.query(cached(customersQuery(deps))),
  component: lazyRouteComponent(() => import('./pages'), 'CustomersPage'),
})

export const customerRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('customers'),
  path: '/customers/$id',
  validateSearch: customerSearch,
  loader: ({ context, params }) => context.queryClient.query(cached(customerQuery(params.id))),
  component: lazyRouteComponent(() => import('./pages'), 'CustomerPage'),
})

export const customerRoutes = [customersRoute, customerRoute]
